import { render, staticRenderFns } from "./selectApprovalUserRole.vue?vue&type=template&id=0be9c618&scoped=true"
import script from "./selectApprovalUserRole.vue?vue&type=script&lang=js"
export * from "./selectApprovalUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9c618",
  null
  
)

export default component.exports